export function FormErrors({ errors }) {
  if (!errors?.length) return null;

  return (
    <div className="form-error" role="alert">
      {errors.map((error) => (
        <p key={error}>{error}</p>
      ))}
    </div>
  );
}
